"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueSeq = exports.sortBy = exports.some = exports.set = exports.reduce = exports.map = exports.keyedEquivalent = exports.keySeq = exports.has = exports.get = exports.forEach = exports.flattenN = exports.filter = exports.every = exports.entrySeq = exports.concat = exports.count = exports.clear = void 0;

var _always = _interopRequireDefault(require("../always"));

var _isFunction = _interopRequireDefault(require("../isFunction"));

var _isNumber = _interopRequireDefault(require("../isNumber"));

var _protocol = _interopRequireDefault(require("../protocol"));

var isAnyValue = (0, _always.default)(true);
var clear = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'clear'
});
/**
 * @private
 * Returns the number of values in `subject`.
 *
 * @param {TYPE} subject
 * @return {number}
 */

exports.clear = clear;
var count = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'count'
});
/**
 * @private
 * Returns a concatenated `subject` and `update`.
 *
 * @param {any} update
 * @param {TYPE} subject
 * @return {number}
 */

exports.count = count;
var concat = (0, _protocol.default)({
  args: [isAnyValue, // update
  _protocol.default.TYPE],
  name: 'concat'
});
/**
 * @private
 * Returns a Seq of key,value tuples (in JS Array)
 *
 * @param {TYPE}
 * @return {Seq<[any, any]>}
 */

exports.concat = concat;
var entrySeq = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'entrySeq'
});
/**
 * @private
 * Returns true if `predicate` returns `true` for _all_ items in `subject`.
 *
 * @param {Function} predicate
 * @param {TYPE} subject
 * @return {bool}
 */

exports.entrySeq = entrySeq;
var every = (0, _protocol.default)({
  args: [_isFunction.default, // predicate
  _protocol.default.TYPE],
  name: 'every'
});
/**
 * @private
 * Returns a new value of items in `subject` for which `predicate` returns `true`.
 *
 * @param {Function} predicate
 * @param {TYPE} subject
 */

exports.every = every;
var filter = (0, _protocol.default)({
  args: [_isFunction.default, // predicate
  _protocol.default.TYPE],
  name: 'filter'
});
exports.filter = filter;
var flattenN = (0, _protocol.default)({
  args: [_isNumber.default, // depth
  _protocol.default.TYPE],
  name: 'flattenN'
});
exports.flattenN = flattenN;
var forEach = (0, _protocol.default)({
  args: [_isFunction.default, // effect
  _protocol.default.TYPE],
  name: 'forEach'
});
/**
 * @private
 * Return the value of `key` in `subject`.
 *
 * @param {any} key
 * @param {TYPE} subject
 * @return {any}
 */

exports.forEach = forEach;
var get = (0, _protocol.default)({
  args: [isAnyValue, // key
  _protocol.default.TYPE],
  name: 'get',
  fallback: function fallback(key, obj) {
    return obj[key];
  }
});
/**
 * @private
 * Returns `true` if `key` is in `subject`'s keys.
 *
 * @param {any} key
 * @param {TYPE} subject
 * @return {any}
 */

exports.get = get;
var has = (0, _protocol.default)({
  args: [isAnyValue, // key
  _protocol.default.TYPE],
  name: 'has'
});
/**
 * @private
 * Return a `Seq` of the keys in `subject`.
 *
 * @param {TYPE<K, _>} subject
 * @return {Seq<K>}
 */

exports.has = has;
var keySeq = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'keySeq'
});
exports.keySeq = keySeq;
var keyedEquivalent = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'keyedEquivalent'
});
/**
 * @private
 * Returns a new value by applying `mapper` to each item in `subject`.
 *
 * @param {Function} mapper
 * @param {TYPE} subject
 * @return {TYPE}
 */

exports.keyedEquivalent = keyedEquivalent;
var map = (0, _protocol.default)({
  args: [_isFunction.default, // mapper
  _protocol.default.TYPE],
  name: 'map'
});
/**
 * @private
 * Returns a new value by applying `mapper` to each item in `subject`.
 *
 * @param {Function} mapper
 * @param {TYPE} subject
 * @return {TYPE}
 */

exports.map = map;
var reduce = (0, _protocol.default)({
  args: [isAnyValue, // accumulator
  _isFunction.default, // reducer
  _protocol.default.TYPE],
  name: 'reduce'
});
/**
 * @private
 * Set the `value` of `key` in `subject`.
 *
 * @param {any} value
 * @param {any} key
 * @param {TYPE} subject
 * @return {TYPE}
 */

exports.reduce = reduce;
var set = (0, _protocol.default)({
  args: [isAnyValue, // value
  isAnyValue, // key
  _protocol.default.TYPE],
  name: 'set'
});
/**
 * @private
 * Returns true if `predicate` returns `true` for _any_ items in `subject`.
 *
 * @param {Function} predicate
 * @param {TYPE} subject
 * @return {bool}
 */

exports.set = set;
var some = (0, _protocol.default)({
  args: [_isFunction.default, // predicate
  _protocol.default.TYPE],
  name: 'some'
});
/**
 * @private
 * Returns a copy of `subject` sorted according to `getSortValue`.
 *
 * @param {Function} getSortValue
 * @param {TYPE} subject
 * @return {TYPE}
 */

exports.some = some;
var sortBy = (0, _protocol.default)({
  args: [_isFunction.default, // getSortValue
  _protocol.default.TYPE],
  name: 'sortBy'
});
/**
 * @private
 * Return a `Seq` of the values in `subject`.
 *
 * @param {TYPE<_, V>} subject
 * @return {Seq<K>}
 */

exports.sortBy = sortBy;
var valueSeq = (0, _protocol.default)({
  args: [_protocol.default.TYPE],
  name: 'valueSeq'
});
exports.valueSeq = valueSeq;